<template>
  <div>
    <div class="row table-row-background-color  non-mobile-monitor-table">
      <div class="center-row-1">{{ row.Name }}</div>

      <div class="center-row-1" v-bind:title="abbShipDetails"> {{ abbShipDetails }}</div>



      <div class="center-row-1">{{ row.IMO }}</div>
      <div class="center-row-1">
        {{ row.DeadWeight }}
      </div>
      <div class="center-row-1">
        {{ row.TotalDistance }} {{ row.TotalDistanceMeasurementUnit }}
      </div>
      <div class="center-row-1">
        {{ row.CO2Emission }} {{ row.CO2EmissionMeasurementUnit }}
      </div>
      <div class="center-row-2">{{ row.AttainedCII }} grCO2/nm*mt</div>
      <div class="center-row-2">{{ row.RequiredCII }} grCO2/nm*mt</div>
      <div class="center-row-3">{{ row.DifferenceCIIWithRequired }}</div>
      <div class="center-row-3">{{ row.DifferenceCIIWithRequiredPerCent }}</div>
   
      <div class="center-row-2">
        <div v-bind:class="colorSelected">{{ row.GradeRating }}</div>
      </div>
      <div class="center-row-2">
        <button type="button" class="btn btn-primary ship-selector-button" style="margin-bottom: 10px"
          v-on:click="details">
          Details
        </button>
      </div>
    </div>




    <div class="row table-row-background-color  mobile-monitor-table">
      <div class="center-row-2">{{ row.Name }}</div>
      <div class="center-row-1">{{ row.IMO }}</div>
      <div class="center-row-2">{{ row.AttainedCII }} grCO2/nm*mt</div>
      <div class="center-row-2">{{ row.RequiredCII }} grCO2/nm*mt </div>
      <div class="center-row-2">
        <div v-bind:class="colorSelected">{{ row.GradeRating }}</div>
      </div>
      <div class="center-row-2">
        <button type="button" class="btn btn-primary ship-selector-button" style="margin-bottom: 10px"
          v-on:click="details">
          Details
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import Popper from "vue3-popper";
export default {
  name: "EmsRow",
  props: ["row"],
  data() {
    return {
      components: {
        Popper,
      },
      name: "EmsRow",
    };
  },
  methods: {
    details: function () {
      this.$emit("changedSelect", this.row);
    },
  },

  computed: {

    abbShipDetails() {
     if(this.row.shipDetails){
      return this.row.shipDetails.split(' ').slice(0, 3).join(' ');
     }
    },
    colorSelected() {

      if (this.row.GradeRating == "A") {
        return "ship-grade-a-indicator";
      }

      if (this.row.GradeRating == "B") {
        return "ship-grade-b-indicator";
      }

      if (this.row.GradeRating == "C") {
        return "ship-grade-c-indicator";
      }

      if (this.row.GradeRating == "D") {
        return "ship-grade-d-indicator";
      }

      if (this.row.GradeRating == "E") {
        return "ship-grade-e-indicator";
      }
    },
    mounted: function () { },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.center-row-1 {
  margin: auto;
  width: 8%;
}

.center-row-2 {
  margin: auto;
  width: 10%;
}

.center-row-3 {
  margin: auto;
  width: 6%;
}
</style>
